import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({delete: "topicFlagDelete"})
export default class TopicFlag {

	// maybe should make this return... something else????

	@Field()
	public entityId: ID;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/TopicFlag.ts